module.exports = __webpack_public_path__ + "static/media/IMG_3988 vanity side.a012512f.JPG";